import { Separator } from "@chakra-ui/react-v3";
import { ImagingReportRowData } from "../tables/notes/imaging-reports-rows";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { NoteDisplay } from "../components/note-display";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { ResourceAnalysis } from "../components/resource-analysis";

export type ImagingReportSidePanelContentProps = {
  data: ImagingReportRowData;
};

export function ImagingReportSidePanelContent({ data }: ImagingReportSidePanelContentProps) {
  const subtitle = [data.imagingModality, data.bodyRegion].filter(v => v && v !== "-").join(" - ");

  return (
    <SidePanelLayout title="Imaging Report" subtitle={subtitle} metadata={data.date}>
      {/* AI Analysis Section (if available) */}
      <ResourceAnalysis />

      {/* Note Display Section */}
      <NoteDisplay resource={data.originalData} />

      <Separator borderColor="border" />

      {/* Documents Section */}
      <DocumentsSection resources={[data.originalData]} resourceType="ImagingReports" />
    </SidePanelLayout>
  );
}
